import { ReactNode, useState } from "react";
import {
  ClickAwayListener,
  IconButtonProps,
  Tooltip as MuiToolTip,
  IconButton,
  TooltipProps,
} from "@mui/material";
import { TooltipIcon } from "../assets/icons/TooltipIcon";

type Props = Omit<TooltipProps, "title" | "children"> &
  Pick<IconButtonProps, "size" | "sx"> & {
    dataTestId: string;
    tooltip: ReactNode;
  };

export function Tooltip({
  dataTestId,
  tooltip,
  size = "small",
  sx,
  componentsProps,
}: Props) {
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);

  const handleHelpIconClick = () => {
    setTooltipOpen(true);
  };

  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <MuiToolTip
        onClose={handleTooltipClose}
        placement="bottom-start"
        open={tooltipOpen}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={tooltip}
        componentsProps={componentsProps}>
        <IconButton
          aria-label="Additional information"
          type="button"
          sx={sx}
          size={size}
          onClick={handleHelpIconClick}
          data-testid={`${dataTestId}-tooltip`}>
          <TooltipIcon />
        </IconButton>
      </MuiToolTip>
    </ClickAwayListener>
  );
}
